(function ($) {

    const MAX_SIZE = 20 * 1024 * 1024;

    function uploadFile(input, hiddenField) {

        $(document).on('change', input, function () {

            const file = this.files[0];

            if (!file)
                return;

            const wrapper = $(this).closest('label');
            const validation = wrapper.find('.file-upload-validation');

            validation.hide();

            if (file.size > MAX_SIZE) {

                validation
                    .text('Exceeded max file size limit (20MB)')
                    .show();

                this.value = '';

                return;
            }

            let data = new FormData();

            data.append('action', 'handle_file_upload');
            data.append('security', ajax_object.ajax_nonce);
            data.append('file', file);

            $.ajax({

                url: ajax_object.ajaxurl,
                type: 'POST',
                data: data,
                processData: false,
                contentType: false,

                success: function (response) {

                    if (response.success) {

                        $(hiddenField).val(response.data.file_url);

                    } else {

                        validation
                            .text(response.data)
                            .show();
                    }

                }

            });

        });

    }

    $(function () {

        uploadFile('#ID', '#id_file_url');
        uploadFile('#Bank', '#bank_file_url');
        uploadFile('#Address', '#address_file_url');
        uploadFile('#RouterMandate', '#router_acknowledgement_mandate_file_url');

    });

})(jQuery);